import { render, staticRenderFns } from "./SwitchCompanyMenu.vue?vue&type=template&id=17267b22&scoped=true"
import script from "./SwitchCompanyMenu.vue?vue&type=script&lang=js"
export * from "./SwitchCompanyMenu.vue?vue&type=script&lang=js"
import style0 from "./SwitchCompanyMenu.vue?vue&type=style&index=0&id=17267b22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17267b22",
  null
  
)

export default component.exports